<script>
  import FinalScore from "./FinalScore.svelte"
  import { fade } from "svelte/transition"
  import { _ } from "svelte-i18n"
</script>

<div id="finished-container">
  <div id="finished" transition:fade={{ duration: 1500 }}>
    {$_("finaleMessage")}
  </div>
  <FinalScore />
  <a href="/" class="start-over">{$_("playAgain")}</a>
</div>

<style>
  #finished-container {
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 80px;
  }
  #finished {
    font-size: 4rem;
    color: white;
    background: rgba(0, 0, 0, 0.6);
    padding: 30px 40px;
    border-radius: 20px;
    text-align: center;
  }

  a.start-over {
    /* margin: 20px auto; */
    display: block;
    padding: 12px 20px;
    font-size: 1.8rem;
    border-radius: 10px;
    color: black;
    background: #3ddfdf;
    width: fit-content;
    text-decoration: none;
    border: 4px solid #ff7940;
  }

  a.start-over:hover {
    background: #8bfdfd;
  }

  @media (max-width: 600px) {
    a.start-over {
      font-size: 1.5rem;
    }

    #finished {
      font-size: 1.8rem;
      padding: 20px 30px;
    }
  }
</style>
